module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "background": "#f7f7f7"
    }
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-banner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contact-package"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact-package-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-qq"
  }), _vm._v(" "), _c('a', {
    staticClass: "qq-line",
    attrs: {
      "href": 'mqqwpa://im/chat?chat_type=wpa&uin=' + _vm.msg.kefu + '&version=1&src_type=web&web_src=m.abeiyun.com'
    }
  }, [_c('i', {
    staticClass: "icon-QQ"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_vm._v("\n            阿贝云售前部为您服务\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_vm._v("\n            QQ号码：" + _vm._s(_vm.msg.kefu) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-gongdan"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "submit-gongdan",
    attrs: {
      "to": "/user/gongdan"
    }
  }, [_vm._v("\n          提交售前咨询工单\n        ")])], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "contact-package"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "contact-package-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-qq"
  }), _vm._v(" "), _c('a', {
    staticClass: "qq-line",
    attrs: {
      "href": 'mqqwpa://im/chat?chat_type=wpa&uin=' + _vm.msg.beian + '&version=1&src_type=web&web_src=m.abeiyun.com'
    }
  }, [_c('i', {
    staticClass: "icon-QQ"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_vm._v("\n            阿贝云备案部为您服务\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-row"
  }, [_vm._v("\n            QQ号码：" + _vm._s(_vm.msg.beian) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-gongdan"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "submit-gongdan",
    attrs: {
      "to": "/user/gongdan"
    }
  }, [_vm._v("\n          提交备案咨询工单\n        ")])], 1), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "contact-package"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "contact-package-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-gongdan"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "submit-gongdan",
    attrs: {
      "to": "/user/gongdan"
    }
  }, [_vm._v("\n          提交售后咨询工单\n        ")])], 1), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact_top"
  }, [_c('div', {
    staticClass: "nav-links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("服务条款")])], 1)])])]), _vm._v(" "), _vm._m(13)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_title"
  }, [_c('h4', [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-package-title"
  }, [_c('div', {
    staticClass: "package-title-text "
  }, [_c('span', [_vm._v("售前咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "package-subtitle-text"
  }, [_vm._v("\n        解决您使用前的任何疑问\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-phone"
  }), _vm._v("\n        400-101-2890 按1键\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-time"
  }), _vm._v(" "), _c('span', {
    staticClass: "word-time"
  }, [_vm._v("\n                              工作时间：08:30AM-21:00PM\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-package-title"
  }, [_c('div', {
    staticClass: "package-title-text text-center "
  }, [_c('span', [_vm._v("备案咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "package-subtitle-text"
  }, [_vm._v("\n        解决您网站域名ICP备案的问题\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-phone"
  }), _vm._v("\n        400-101-2890 按2键\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-time"
  }), _vm._v(" "), _c('span', {
    staticClass: "word-time"
  }, [_vm._v("\n                              工作时间：08:30AM-21:00PM\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-package-title"
  }, [_c('div', {
    staticClass: "package-title-text text-center "
  }, [_c('span', [_vm._v("售后咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "package-subtitle-text"
  }, [_vm._v("\n        解决您产品使用过程中遇到的问题\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item-s"
  }, [_c('p', [_vm._v("售后工程师仅提供在线工单的形式，如")]), _vm._v(" "), _c('p', [_vm._v("有需要请在工单中提交您的联系方式，")]), _vm._v(" "), _c('p', [_vm._v("工程师将会和您主动联系。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "icon-time"
  }), _vm._v(" "), _c('span', {
    staticClass: "word-time"
  }, [_vm._v("\n                              工作时间：08:30AM-21:00PM\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hezuo"
  }, [_c('h4', [_vm._v("商务合作")]), _vm._v(" "), _c('p', [_vm._v("非常欢迎同行、投资者、CMS作者合作")]), _vm._v(" "), _c('p', [_vm._v("发邮件到 Lin@abeiyun.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hezuo"
  }, [_c('h4', [_vm._v("意见建议")]), _vm._v(" "), _c('p', [_vm._v("欢迎您提出宝贵意见，我们一定虚心接受")]), _vm._v(" "), _c('p', [_vm._v("发邮件到 accept@abeiyun.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adress"
  }, [_c('h4', [_vm._v("陕西云游四海网络科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("陕西省西安市高新区高新四路财富中心C座11层1117室")]), _vm._v(" "), _c('p', [_vm._v("企业总机：400-101-2890 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_bottom clearfix"
  }, [_c('a', {
    staticClass: "logo-bottom",
    attrs: {
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weixin-b"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.32rem"
    },
    attrs: {
      "href": "https://www.abeiyun.com"
    }
  }, [_vm._v("切换电脑版")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_bottom_r"
  }, [_vm._v("\n          ©2018 abeiyun All rights reserved\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631cfe20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/contact.vue
// module id = 3IVR
// module chunks = 1